import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gou",
  "use": "icon-gou-usage",
  "viewBox": "0 0 1498 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1498 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-gou\"><defs><style type=\"text/css\"></style></defs><path d=\"M618.396098 1024L0 403.605854l140.862439-141.861464 477.533659 479.531708L1357.674146 0 1498.536585 140.862439l-880.140487 883.137561z\" p-id=\"2487\" fill=\"#0dbe00\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol